{
	"title": "Available materials",
	"showAllTitle": "Show all materials",
	"table": {
		"material": "Material",
		"invoicedQuantity": "Invoiced quantity",
		"remainingForTransfer": "Remaining for declaration creation",
		"fetchError": "Could not fetch materials",
		"noMaterials": {
			"title": "No materials available",
			"description": "You currently have no materials available on the {{productName}}. Please contact your sales representative to add your contract(s) to your account."
		}
	}
}
